import React from 'react'
import { Button } from '@mantine/core'
import { useRequestTokensMutation } from '../mutations'

const AirdropRequestTokensButton = () => {
  const { mutateAsync, isLoading } = useRequestTokensMutation()

  const handleClick = () => {
    mutateAsync()
  }

  return (
    <Button loading={isLoading} onClick={handleClick} size="lg" radius="md" fullWidth>
      Request Tokens
    </Button>
  )
}

export { AirdropRequestTokensButton }
